import { render, staticRenderFns } from "./Drugs.vue?vue&type=template&id=791f46ba&"
import script from "./Drugs.vue?vue&type=script&lang=js&"
export * from "./Drugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports